import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-07a38509"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "mt-10" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ProfileEditPersonal = _resolveComponent("ProfileEditPersonal")!
  const _component_ProfileEditWorkplaces = _resolveComponent("ProfileEditWorkplaces")!
  const _component_ProfileEditEducation = _resolveComponent("ProfileEditEducation")!
  const _component_ProfileEditContacts = _resolveComponent("ProfileEditContacts")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_ProfileEditPersonal),
    _createVNode(_component_ProfileEditWorkplaces),
    _createVNode(_component_ProfileEditEducation),
    _createVNode(_component_ProfileEditContacts)
  ]))
}